export const SCROLLSPY_LOCALE_ZHCHS = {
    guide: 'å¯¼èª'
};
